import  {__extends} from './eXcell';
import  eXcell_co from './eXcell_co';

var eXcell_corotxt = (function (_super) {
    __extends(eXcell_corotxt, _super);
    function eXcell_corotxt(a) {
        _super.call(this, a);
        this.editable = false;
    }
    return eXcell_corotxt;
})(eXcell_co);
window.eXcell_corotxt = eXcell_corotxt;



// WEBPACK FOOTER //
// ./goingsrc/dx/dxSource/components/gridXCell/eXcell_corotxt.js